import { ref } from 'vue';

interface SupportCode {
  id: number;
  code: string;
  enumName: string;
  description: string;
  active: boolean;
  status: number;
}

const supportCodesData = ref<SupportCode[]>([]);
const isInitialized = ref<boolean>(false);

function setSupportCodesData(codes: SupportCode[]): void {
  supportCodesData.value = codes || [];
  isInitialized.value = true;
}

function getActiveSupportCodes(): SupportCode[] {
  return supportCodesData.value.filter((c) => c.active);
}

function getSupportCodeByCode(code: string): SupportCode | null {
  return supportCodesData.value.find((c) => c.code === code) || null;
}

/**
 * Array formatted for dropdowns with active codes.
 * value = code (string "01", "02", etc.)
 * label = i18n key resolved by DropdownSelect
 */
function getActiveSupportCodesArray(): Array<{ value: string; label: string }> {
  return supportCodesData.value
    .filter((c) => c.active)
    .map((c) => ({
      value: c.code,
      label: `enums.supportcode.${c.enumName.toLowerCase()}`,
    }));
}

function hasSupportCodesData(): boolean {
  return isInitialized.value && supportCodesData.value.length > 0;
}

function clearSupportCodesData(): void {
  supportCodesData.value = [];
  isInitialized.value = false;
}

export default {
  supportCodesData,
  isInitialized,
  setSupportCodesData,
  getActiveSupportCodes,
  getSupportCodeByCode,
  getActiveSupportCodesArray,
  hasSupportCodesData,
  clearSupportCodesData,
};

export type { SupportCode };
